"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceDescriptionController = /** @class */ (function () {
    function ServiceDescriptionController($uibModal, taskTypesApi, toaster) {
        this.$uibModal = $uibModal;
        this.taskTypesApi = taskTypesApi;
        this.toaster = toaster;
    }
    ServiceDescriptionController.prototype.$onInit = function () {
        var locationUrl = location.href;
        var keyword = 'openDialog=';
        if (locationUrl.indexOf(keyword) !== -1) {
            var serviceId = locationUrl.substr(locationUrl.indexOf(keyword) + keyword.length);
            this.addService(parseInt(serviceId));
        }
    };
    ServiceDescriptionController.prototype.addService = function (serviceId) {
        var _this = this;
        this.taskTypesApi.canUserCreateTask({ id: serviceId }, function (result) {
            if (result.canCreateTask === true) {
                var modalInstance = _this.$uibModal.open({
                    templateUrl: '/serviceCreationDialog.html',
                    controller: 'serviceDialogCtrl',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        model: function () {
                            return {
                                taskType: serviceId
                            };
                        }
                    }
                });
                modalInstance.result.then();
            }
            else {
                _this.toaster.pop('error', 'Service cannot be added', 'You need to be verified before you will be able to add this service');
            }
        });
    };
    ServiceDescriptionController.prototype.openGenericForm = function (servicePageTitle, servicePageId, servicePageLink) {
        var modalInstance = this.$uibModal.open({
            templateUrl: '/genericFormDialog.html',
            controller: 'genericFormDialogCtrl',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
                servicePage: function () {
                    return {
                        title: servicePageTitle,
                        id: servicePageId,
                        url: servicePageLink
                    };
                }
            }
        });
        modalInstance.result.then();
    };
    return ServiceDescriptionController;
}());
exports.ServiceDescriptionController = ServiceDescriptionController;
//# sourceMappingURL=data:application/json;base64,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